import type { AuthMeResponse } from "@shared/types/auth";

interface GrantPlaceOnly {
  readonly place: { readonly kind: string; readonly id: string };
}

/** "Where a user lands" in docs/permissions.md. */
export type Landing =
  | { readonly kind: "company" }
  | { readonly kind: "premises"; readonly premiseIds: readonly string[] };

export function landingFor(
  grants: readonly GrantPlaceOnly[] | null | undefined
): Landing {
  if (!grants || grants.length === 0) return { kind: "company" };
  if (grants.some((g) => g.place.kind === "company")) {
    return { kind: "company" };
  }
  const premiseIds: string[] = [];
  for (const g of grants) {
    if (g.place.kind === "premise" && !premiseIds.includes(g.place.id)) {
      premiseIds.push(g.place.id);
    }
  }
  return { kind: "premises", premiseIds };
}

/** `/auth/me`'s `access.grants`; absent until the server sends them. */
export function grantsOfSession(
  user: AuthMeResponse | null | undefined
): readonly GrantPlaceOnly[] | undefined {
  const access = (user as { access?: { grants?: unknown } } | null | undefined)
    ?.access;
  return Array.isArray(access?.grants)
    ? (access.grants as GrantPlaceOnly[])
    : undefined;
}
